import { Component, OnInit, forwardRef } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  LoadingController,
  AlertController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { GrupoCheckPessoaDetalhesPage } from "../grupo-check-pessoa-detalhes/grupo-check-pessoa-detalhes.page";
import { GrupoCheckResponsavelPage } from "../grupo-check-responsavel/grupo-check-responsavel.page";
import { ModalPessoaPage } from "../../modal-pessoa/modal-pessoa.page";
import { GrupoProvider } from "src/app/services/grupo/grupo";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ImagePipe } from "src/app/pipes/image/image";

@Component({
  selector: "app-grupo-check-pessoa",
  templateUrl: "./grupo-check-pessoa.page.html",
  styleUrls: ["./grupo-check-pessoa.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
  ],
})
export class GrupoCheckPessoaPage implements OnInit {
  pessoa: any = {};
  isMenor: boolean = false;
  idReuniao: any = "";
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public pessoaProvider: PessoaProvider,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public alertCtrl: AlertController
  ) {
    this.pessoa = this.navParams.get("pessoa");
    this.idReuniao = this.navParams.get("idReuniao");

    this.grupoProvider.checkIsMenorIdade(this.pessoa.id).subscribe((data) => {
      this.isMenor = data;
    });
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async check() {
    this.pessoaProvider
      .getFamiliaresAutorizadosById(this.pessoa.id)
      .subscribe(async (data) => {
        const temResponsaveis = data.length > 0;

        if (this.isMenor && !temResponsaveis) {
          const alert = await this.alertCtrl.create({
            cssClass: "alerta-personalizado",
            mode: "ios",
            header: this.translate.instant("Erro"),
            subHeader: this.translate.instant(
              "A pessoa selecionada é menor de idade e não possui nenhum responsável cadastrado."
            ),
            buttons: ["OK"],
          });
          await alert.present();
          return;
        }

        let component: any;
        let componentProps: any = {
          pessoa: this.pessoa,
          isMenor: this.isMenor,
          idReuniao: this.idReuniao,
        };

        if (this.isMenor && data.length > 1) {
          component = GrupoCheckResponsavelPage;
          componentProps.responsaveis = data;
        } else if (data.length == 1 && this.isMenor) {
          component = GrupoCheckPessoaDetalhesPage;
          componentProps.responsavel = data[0] || null;
        } else if (!this.isMenor) {
          component = GrupoCheckPessoaDetalhesPage;
          componentProps.responsavel = null;
        }

        const modal = await this.modalCtrl.create({
          component,
          componentProps,
        });
        await modal.present();

        const result = await modal.onDidDismiss();
        if (result.data) {
          this.modalCtrl.dismiss(true);
        }
      });
  }

  async detalhesResponsavel(idResponsavel: any) {
    const detalhes = { idPessoa: idResponsavel, meuCadastro: false };
    const modalPage = await this.modalCtrl.create({
      component: ModalPessoaPage,
      componentProps: detalhes,
    });

    modalPage.present();
  }
}
